import { useLazyQuery, useMutation } from '@apollo/client';
import { Card } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '../../../common/constants';
import GoBackButton from '../../../components/GoBackButton';
import Portal from '../../../components/Portal';
import history from '../../../historyData';
import PropertyCreationModal from '../components/PropertyCreationModal';
import PropertyForm from '../components/PropertyForm';
import CardWrapper from '../components/PropertyTabs';
import { CREATE_PROPERTY } from '../graphql/Mutations';
import { GET_PROPERTIES } from '../graphql/Queries';

function PropertyCreate() {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [duplicateData, setDuplicateData] = useState([]);
  const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);

  const [createProperty] = useMutation(CREATE_PROPERTY, {
    onError: () => {
      setSubmitLoading(false);
    }
  });

  const submitData = async () => {
    setSubmitLoading(true);
    const newFormValues = {
      ...formData,
      location: {
        addressLine1: formData?.addressLine1,
        city: formData?.city,
        state: formData?.state,
        country: formData?.country,
        zipCode: formData?.zipCode
      },
      builtYear: moment(formData?.builtYear).format('YYYY')
    };

    delete newFormValues?.addressLine1;
    delete newFormValues?.city;
    delete newFormValues?.state;
    delete newFormValues?.country;
    delete newFormValues?.zipCode;

    const variables = { data: newFormValues };

    try {
      const response = await createProperty({
        variables: { ...variables }
      });
      if (response?.data?.createProperty) {
        const { id } = response?.data?.createProperty?.data;
        setSubmitLoading(false);
        setDuplicateModalVisible(false);
        history?.push(`${ROUTES?.PROPERTIES}/edit${ROUTES?.CUSTOMERS}/${id}`);
      }
    } catch (error) {
      setSubmitLoading(false);
      setDuplicateModalVisible(false);
      return error;
    }
  };

  const [fetchPropertiesData] = useLazyQuery(GET_PROPERTIES, {
    fetchPolicy: 'network-only',
    onCompleted: async (res) => {
      if (res?.properties?.data?.length > 0) {
        setDuplicateData(res?.properties?.data);
        setDuplicateModalVisible(true);
        setSubmitLoading(false);
      } else {
        submitData();
      }
    },
    onError: () => {
      setSubmitLoading(false);
    }
  });

  const handleSubmit = async (formValues) => {
    setSubmitLoading(true);
    setFormData(formValues);

    fetchPropertiesData({
      variables: {
        filter: {
          sortOn: 'createdAt',
          sortBy: 'DESC'
        },
        where: {
          duplicateCheck: true,
          addressLine: [formValues?.addressLine1]
        }
      }
    });
  };

  const initialValues = {
    country: 'USA'
  };

  return (
    <Card className="full-height-card card-body-padding">
      <PropertyCreationModal
        showModal={duplicateModalVisible}
        setShowModal={setDuplicateModalVisible}
        duplicateData={duplicateData}
        submitData={submitData}
        submitLoading={submitLoading}
      />
      <Portal portalId="header-left-content">
        <div className="d-flex align-center">
          <GoBackButton customLink={ROUTES?.PROPERTIES} />
          <span className="portal-header">Add Property</span>
        </div>
      </Portal>
      <CardWrapper>
        <PropertyForm
          propertyData={initialValues}
          handleSubmit={handleSubmit}
          isSubmit={submitLoading}
        />
      </CardWrapper>
    </Card>
  );
}

export default withRouter(PropertyCreate);
